export enum ActivityNameStatus {
    CREATED = 'CREATED',
    BILLED = 'BILLED',
    PAID = 'PAID',
    PAYMENT_FAILED = 'PAYMENT_FAILED',
    UNCOLLECTIBLE = 'UNCOLLECTIBLE',
}
